import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
/**
 * this is used to guard new briefing, release etc. App initial load should not reach those 'create new' urls.
 */
@Injectable()
export class CreateNewActivateGuard implements CanActivate {
    constructor( private router: Router ) {   }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if (this.router.url === '/') {
            // this.router.url === '/' means the initial load of the app
            // then redirect to its parent route --- hype page
            const index = state.url.lastIndexOf('/');
            this.router.navigate([state.url.substring(0, index)]);
            return false;
        } else {
            return true;
        }
    }
}
